import React from 'react'
import { useGlobalState } from 'state'
import { IDs } from 'common/consts'

export const BuildingPlateauLayer = () => {
  const state = useGlobalState()

  React.useEffect(() => {
    if (!state.mapbox) return
    state.mapbox.on('style.load', load)

    return () => {
      if (!state.mapbox) return
      state.mapbox.off('style.load', load)
    }
  }, [state.mapbox])

  React.useEffect(() => {
    if (!state.mapbox) return
    if (state.map.buildingType === 'Plateau') {
      load()
    } else {
      remove()
    }
  }, [state.map.buildingType])

  const remove = () => {
    if (!state.mapbox) return
    state.map.removeLayer(IDs.plateau.layer)
    state.map.removeSource(IDs.plateau.layer)
  }

  const load = () => {
    if (!state.mapbox) return
    if (state.map.buildingType !== 'Plateau') return

    state.map.addSource(IDs.plateau.source, {
      'type': 'vector',
      'tiles': [
        'https://d6sqzjnempi2y.cloudfront.net/shizuoka/shizuokashi/{z}/{x}/{y}.pbf',
      ],
      'minzoom': 10,
      'maxzoom': 16,
    })
    state.map.addLayer({
      'id': IDs.plateau.layer,
      'type': 'fill-extrusion',
      'source': IDs.plateau.source,
      'source-layer': 'bldg',
      'minzoom': 11,
      'maxzoom': 20,
      'filter': ['has', 'measuredHeight'],
      'paint': {
        'fill-extrusion-color': '#1d508e',
        'fill-extrusion-height': ['*', ['get', 'measuredHeight'], 1],
        'fill-extrusion-opacity': 0.9,
        // 'fill-extrusion-base': 0,
      }
    })
  }

  return (
    <></>
  )
}
